import Image from 'next/legacy/image'
import styled from 'styled-components'

import { useWhiteLabelling } from '@/context/whiteLabelContext'
import { deterministicThemeColour } from '@/utils/index'

import { buildPassTheme } from 'src/styles/theme'

import { ProjectStatus } from 'types/api.graphql'
import { ProjectLike } from 'types/vagueTypes'

export type WrapperProps = {
  bold?: boolean
  inline?: boolean
  baseColour?: boolean
}

export const ProjectIconWrapper = styled.span<WrapperProps>`
  ${({ theme }) => theme.font.body03}
  font-weight: ${({ bold = true }) => (bold ? 600 : 400)};
  color: ${({ baseColour, theme }) =>
    baseColour ? theme.colour.secondary.base : 'inherit'};
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  align-items: center;
  gap: 0.5rem;
`

const Wrapper = styled.div`
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;

  & img {
    mix-blend-mode: hard-light;
  }
`

export const getProjectColour = (project: ProjectLike) => {
  if (!project?.id) return null

  return project.status === ProjectStatus.Complete
    ? buildPassTheme.colour.secondary._200
    : deterministicThemeColour(project.id)
}

type Props = {
  colour: string
  size?: number
}

export const ProjectIcon: React.FC<Props> = ({ colour, size = 40 }) => {
  const { projectIcon } = useWhiteLabelling()
  return (
    <Wrapper
      style={{
        backgroundColor: colour,
        width: `${size * 0.8}px`,
        height: `${size * 0.8}px`,
      }}
    >
      <Image
        src={projectIcon}
        width={size}
        height={size}
        alt="project icon"
        objectFit="cover"
      />
    </Wrapper>
  )
}

export type ProjectIconProps = Props
